import PageBackground from '../../components/Layouts/PageBackground'
import pdf from "../../assets/doc/sweepstakes-rules.pdf"

const SweepsRules = () => {
    return (
        <PageBackground title="SWEEPSTAKES RULES">
            <div className='pdf-box-holder'>
                <iframe src={pdf} title='terms' className='iframe-element' />
            </div>
        </PageBackground>
    )
}

export default SweepsRules
